/**
 * EmptyState — estado vacio canonico del backoffice (features skeleton, tablas sin
 * datos, 404/403, resultados de busqueda vacios).
 * Icono grande en circulo surface-raised + titulo + descripcion + slot para CTA.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
    selector: 'pvp-empty-state',
    imports: [IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <span
        class="flex h-14 w-14 items-center justify-center rounded-full bg-surface-raised text-text-subtle"
        aria-hidden="true"
      >
        <pvp-icon [name]="icon()" size="lg" />
      </span>

      <div class="flex flex-col gap-1">
        <h3 class="m-0 text-[15px] font-semibold text-text">{{ title() }}</h3>
        @if (description()) {
          <p class="m-0 max-w-sm text-[13px] leading-relaxed text-text-muted">
            {{ description() }}
          </p>
        }
      </div>

      <!-- Slot para CTA (pvp-button, routerLink, etc.) -->
      <div class="mt-1 flex items-center gap-2 empty:hidden">
        <ng-content />
      </div>
    </div>
  `
})
export class EmptyStateComponent {
  readonly icon        = input<string>('search');
  readonly title       = input.required<string>();
  readonly description = input<string>('');
}
